// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--1b63ec","tabContent":"style--tabContent--28a349","container":"style--container--eb2290"};